import React from 'react';
import { Carousel } from 'antd';
import PageOne from './page/index.tsx';
import MainMenuCover from './main-menu-cover/index';
import './index.less';
// import Logo from "../../layout/image/logo.png";
import { Link } from 'react-router-dom';

export default class Cover extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            dotPosition: 'left',
        };
        this.carouselRef = undefined;
    }

    componentDidMount() {
        localStorage.setItem('isShowCover', 'true');
    }

    render() {
        const { dotPosition, flow } = this.state;
        return (
            <div className="cover-main-box">
                <div className="head-wrapper">
                    <div className={`head-logo-box`}>
                        {/* <img className={`head-logo`} src={Logo} alt=''/> */}
                        <span className={`head-title`}>地勤</span>
                    </div>
                    <div className="title-box">
                        <Link className="title-item" to="/">
                            点我立即体验
                        </Link>
                    </div>
                </div>
                <Carousel
                    dotPosition={dotPosition}
                    className="cover-wrapper"
                    afterChange={this.demo}
                    ref={(ref) => {
                        this.carouselRef = ref;
                    }}
                >
                    <div
                        className="page"
                        onClick={() => {
                            this.carouselRef.next();
                            this.setState({
                                flow: 'start',
                            });
                        }}
                    >
                        <PageOne></PageOne>
                    </div>
                    <div className="page" onClick={() => (window.location.href = '/')}>
                        <MainMenuCover></MainMenuCover>
                    </div>
                </Carousel>
            </div>
        );
    }
}
